<div class="event-popup">
    <div class="title">
        {{newEvent ? ('bikeshop.modal.add_edit_user.technician_form.event.add_event' | translate) : ('bikeshop.modal.add_edit_user.technician_form.event.edit_event' | translate)}}
    </div>
    <div>
        <div *ngIf="!leaveEvent" class="row margin-top-8">
            <div class="col-md-4 label">{{ 'general.description' | translate }}:</div>
            <div class="col-md-8">
                <input type="text" pInputText [(ngModel)]="event.Description"/>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="!event.ID">
            <div class="col-md-4 label">{{ 'bikeshop.modal.add_edit_user.technician_form.event.recurring' | translate }}
                :
            </div>
            <div class="col-md-8">
                <p-inputSwitch [(ngModel)]="event.IsRecurringEvent"></p-inputSwitch>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="event.IsRecurringEvent">
            <div class="col-md-4 label">{{'bikeshop.modal.add_edit_user.technician_form.event.occurs_every_day' | translate}}
                :
            </div>
            <div class="col-md-8">
                <input type="number" pInputText [(ngModel)]="event.RecurIntervalDays"/>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="event.IsRecurringEvent">
            <div class="col-md-4 label">{{'bikeshop.modal.add_edit_user.technician_form.event.repeats_times' | translate}}
                :
            </div>
            <div class="col-md-8">
                <input type="number" pInputText [(ngModel)]="event.RecurringCount"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-6">
                <button pButton type="button" class="p-button-raised alternate" *ngIf="leaveEvent"
                        label="{{'bikeshop.modal.add_edit_user.technician_form.event.button.delete_event' | translate}}"
                        (click)="deleteEvent()" [disabled]="busy || !valid()"></button>
            </div>
            <div class="col-md-6">
                <button pButton type="button" class="p-button-raised" *ngIf="!leaveEvent"
                        label="{{'bikeshop.modal.add_edit_user.technician_form.event.button.save_event' | translate}}"
                        (click)="saveEvent()" [disabled]="busy || !valid()" style="float: right"></button>
            </div>
        </div>
    </div>
</div>
